<div class="aside-container position-relative" [ngClass]="{ collapsed: isExpanded }">
  <div class="aside-content">
    <div class="aside-tabs">
      @for (item of menuItems; track item) {
        <a class="aside-tab" [matTooltip]="item.pageName || ''" matTooltipPosition="right" [ngClass]="{ active: isActiveRoute(item) }" (click)="onTabChange(item)">
          @if (item.isIcon) {
            @if (item.iconName) {
              <mat-icon class="aside-tab-icon {{ item.iconClass }}">{{ item?.iconName }}</mat-icon>
            }
          }
          @if (!item.isIcon) {
            <div class="aside-tab-icon {{ item.iconClass }}" [innerHtml]="(isActiveRoute(item) ? item?.selectedSvgIcon : item.defaultSvgIcon) | sanitizer: 'html'"></div>
          }
          @if (item.pageName) {
            <span class="aside-tab-text">{{ item.pageName }}</span>
          }
        </a>
      }
    </div>
    @if (isLogOutVisible) {
      <div class="aside-footer">
        <div class="aside-tab" (click)="onLogout()" matTooltip="Logout" matTooltipPosition="right">
          <mat-icon class="text-error">logout</mat-icon>
          <span class="aside-tab-text text-error">Logout</span>
        </div>
      </div>
    }
  </div>
  @if (isExpandable) {
    <div class="expand-action" (click)="onExpand()">
      <mat-icon [inline]="true">{{ isExpanded ? "keyboard_arrow_right" : "keyboard_arrow_left" }}</mat-icon>
    </div>
  }
</div>
